<template>
  <div>
    <DialogBase
      v-model="inputedValue"
      :title="$t('common.input_input-from-history')"
      width="818px"
      :isFooter="true"
      :isPadding0="true"
    >
      <v-container fluid class="baseStyle pa-0">
        <v-row no-gutters class="ma-7">
          <v-col>
            <div class="yCenter">
              <div class="titleStyle">{{ $t(target) }}</div>
              <div class="original-selectbox selectBoxStyle">
                <NormalCombobox
                  v-model="localSelectClientName"
                  :items="comboboxList"
                  height="32px"
                />
              </div>
              <v-spacer> </v-spacer>
              <div>{{ $t('common.input_display-100') }}</div>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-2">
          <v-col cols="12">
            <div class="productTableCom">
              <v-data-table
                :headers="tableHeaders"
                :items="tableData.items"
                :item-key="tableData.itemKey"
                :search="String(localSelectClientName.value)"
                :items-per-page="itemsPerPage"
                hide-default-footer
                :no-results-text="$t('common.common_not-exist-history')"
              >
                <template v-slot:[`item.radioBtn`]="{ item }">
                  <v-radio-group v-model="radioGroup">
                    <v-radio
                      :value="item[tableData.itemKey]"
                      class="pl-2"
                    ></v-radio>
                  </v-radio-group>
                </template>
                <template v-slot:[`item.user`]="{ item }">
                  {{ getUserName(item.user) }}
                </template>
                <template v-slot:[`item.currencyId`]="{ item }">
                  {{ getCurrency(item.currencyId) }}
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  {{ getAmount(item) }}
                </template>
              </v-data-table>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <template #footer>
        <v-spacer> </v-spacer>
        <div class="btnStyle pt-3 pb-2">
          <NormalButton
            :text="$t('common.input_reflect')"
            textSize="16px"
            height="50px"
            width="100%"
            :disabled="radioGroup === ''"
            @click="onClick()"
          />
        </div>
      </template>
    </DialogBase>
  </div>
</template>
<script>
import DialogBase from '@/components/layouts/Dialogs/DialogBase'
import { NormalButton, NormalCombobox } from '@/components/items'
import { currencyUtil } from '@/util'
import { viewConfig } from '@/config'

export default {
  components: {
    DialogBase,
    NormalButton,
    NormalCombobox
  },
  props: {
    value: {
      type: Boolean,
      require: true,
      default: false
    },
    // dialog: { default: false },
    target: { default: '' },
    selectClientName: {
      type: Object,
      require: true,
      default: () => ({ label: '', value: null })
    },
    comboboxList: {
      type: Array,
      require: true,
      default: () => []
    },
    tableData: {
      type: Object,
      require: true,
      default: () => ({
        headers: {
          type: Array,
          require: true,
          default: () => []
        },
        itemKey: {
          type: String,
          require: false,
          default: ''
        },
        items: {
          type: Array,
          require: true,
          default: () => []
        }
      })
    }
  },
  data: () => ({
    radioGroup: '',
    itemsPerPage: viewConfig.DATA_TABLE.ITEMS_PER_PAGE_DEFAULT,

    localSelectClientName: { label: '', value: null }
  }),
  methods: {
    getUserName(user) {
      return user ? user.lastName + user.firstName : '-'
    },
    getCurrency(currencyId) {
      return currencyUtil.getCurrencyIdInfo(currencyId).label
    },
    getAmount(item) {
      let amount = item.productMoves.reduce((sum, ele) => {
        return sum + ele.quantity * Number(ele.price)
      }, 0)
      amount +=
        Number(item.consumptionTax10) +
        Number(item.consumptionTax8) -
        Number(item.discount) +
        Number(item.comission)

      return (
        amount + currencyUtil.findCurrencyNameById(item.currencyId).unitName
      )
    },
    onClick() {
      this.inputedValue = false
      this.$emit('reflect', this.localSelectClientName, this.radioGroup)
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    tableHeaders() {
      const tmp = this.tableData.headers.map((ele) => {
        const params = { ...ele }
        params.text = this.$t(ele.text)
        return params
      })
      return tmp
    }
  },
  watch: {
    inputedValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (!newVal) return
        this.radioGroup = ''
        this.localSelectClientName = this.selectClientName
      }
    },
    localSelectClientName: {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('change', this.localSelectClientName.value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.baseStyle {
  font-size: 14px;
}
#original-expansion-panel::v-deep .v-expansion-panel::before {
  box-shadow: none;
}

.titleStyle {
  font-size: 15px;
  font-weight: bold;
}
.selectBoxStyle {
  width: 340px;
  margin-left: 17px !important;
  // margin: 0px 10px 0px 63px !important;
}
.btnStyle {
  width: 130px;
}

.productTableCom {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1) !important;
    border-collapse: collapse;
    text-align: center !important;
    // padding: 0px 0px !important;
    white-space: pre-wrap;
    background-color: #fafafb;

    border: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;

    border: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;

    padding: 0px 5px !important;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: #fff;
    border-collapse: collapse;

    border: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;

    padding: 0px 5px !important;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }

  .tdStyleCenter {
    text-align: center !important;
  }
  .DisplayNone {
    display: none;
  }
}
</style>
